import { KirbyBlock, KirbyBlockType } from "../queries/blocks"
import { KirbyImageData } from "../queries/image"
import { getCurrentPage } from "./set-page"

export type SlideShowItemType = "image" | "video" | "sketchfab"
export interface SlideShowItem<SlideShowItemType> {
  data:
    | KirbyImageData
    | KirbyBlock<"video">["content"]
    | KirbyBlock<"sketchfab">["content"]
    | null
  id: string
  type?: KirbyBlockType
}

export const convertBlocksToSlideShowItems = (
  blocks: KirbyBlock<KirbyBlockType>[],
): SlideShowItem<SlideShowItemType>[] => {
  const images: KirbyImageData[] | null = getCurrentPage()?.images ?? null

  const convertedBlocks = blocks.map(block => {
    const convertedBlock: SlideShowItem<SlideShowItemType> = {
      data: null,
      id: block.id,
      type: block.type,
    }

    if (!images) return convertedBlock

    if (block.type === "image") {
      const blockImage = block.content.image[0]
      let image = images.find(image => image.uuid === blockImage)
      if (!image) image = images.find(image => image.filename === blockImage)
      if (image)
        convertedBlock.data = { ...image, caption: block.content.caption }
      return convertedBlock as SlideShowItem<"image">
    }
    if (block.type === "video") {
      convertedBlock.data = {
        url: block.content.url,
        caption: block.content.caption,
      }
      return convertedBlock as SlideShowItem<"video">
    }

    if (block.type === "sketchfab") {
      convertedBlock.data = {
        url: block.content.url,
        caption: block.content.caption,
      }
      return convertedBlock as SlideShowItem<"sketchfab">
    }
    return convertedBlock
  })
  return convertedBlocks
}
